import cache from "./cachedState";
import Vue from "vue";

let state = {};

const cachedStateId = "vuex-annotations";
var cachedState = cache.load(cachedStateId);
if (cachedState) {
  state = JSON.parse(cachedState);
}
const saveCache = function(state) {
  cache.save(cachedStateId, JSON.stringify(state));
};

let actions = {};

let getters = {};

let mutations = {
  save(state, annotations) {
    if (!state[annotations.id]) {
      Vue.set(state, annotations.id, {});
    }
    state[annotations.id] = annotations;
    saveCache(state);
  }
};

export default {
  name: "annotation",
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
